<template>
  <g fill="currentColor" transform="translate(-574.5 -5493)">
    <ellipse cx="16" cy="16.5" rx="16" ry="16.5" transform="translate(599.5 5493)"/>
    <path d="M574.5 5539h14v15h-14z" />
    <path d="M608.5 5539h14v15h-14z" />
    <path d="M642.5 5539h14v15h-14z" />
  </g>
</template>
